<script>
    export default {
        name: "FormSwitch",
        props: {
            checked: Boolean,
            text: String,
        },
        model: {
            prop: "checked",
            event: "change",
        },
    };
</script>

<template>
    <div class="form-switch">
        <span class="form-switch__text" v-if="text">
            {{ text }}
        </span>
        <label class="form-switch__label">
            <input
                type="checkbox"
                class="form-switch__input visually-hidden"
                :checked="checked"
                @change="$emit('change', !checked)"
            />
            <span class="form-switch__custom"></span>
        </label>
    </div>
</template>

<style lang="scss">
    .form-switch {
        font-size: 16px;
        line-height: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .form-switch__label {
            display: flex;
            align-items: center;
            max-width: 44px;
        }

        .form-switch__input {
            position: absolute;
            width: 1px;
            height: 1px;
            overflow: hidden;
            opacity: 0;
            &:checked + .form-switch__custom {
                background-color: var(--primary);
            }
            &:checked + .form-switch__custom:before {
                left: 19px;
            }
            @include bp($bp-desktop-sm) {
                &:focus-visible + .form-switch__custom {
                    @include outline;
                }
            }
        }
        .form-switch__custom {
            position: relative;
            display: block;
            background: #e3e9f0;
            width: 40px;
            height: 24px;
            border-radius: 15px;
            transition: background-color 0.2s linear;
            cursor: pointer;
            &:before {
                content: "";
                position: absolute;
                top: 3px;
                left: 3px;
                @include box(18px);
                background: #fff;
                box-shadow: 0 2px 5px 0 rgba(66, 71, 99, 0.3);
                border-radius: 50%;
                transition: left 0.2s linear;
            }
        }
    }

    .form-switch__text {
        color: #000;
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
    }
</style>
